module.exports = __webpack_public_path__ + "img/about.cfc99269.svg";